import { render, staticRenderFns } from "./CanvasWarningBanner.vue?vue&type=template&id=37ce99b1&scoped=true&"
import script from "./CanvasWarningBanner.vue?vue&type=script&lang=js&"
export * from "./CanvasWarningBanner.vue?vue&type=script&lang=js&"
import style0 from "./CanvasWarningBanner.vue?vue&type=style&index=0&id=37ce99b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ce99b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideYTransition})
